import React, { useState } from 'react';
import { Breadcrumb, BreadcrumbGroup, Icon } from '@amzn/storm-ui';
import { ellipsisH } from '@amzn/storm-ui-icons';
import {
  BreadcrumbGroupWrapper,
  EllipsisButton,
  TruncatedPopper,
} from './style';
import { usePageHeaderBundle } from 'src/providers/PantherLocalizationProvider';

interface TruncationIconWithPopoverProps {
  breadcrumbsList: React.ReactNode[];
  allTruncated: boolean;
}

export const TruncationIconWithPopover: React.VFC<
  TruncationIconWithPopoverProps
> = ({ breadcrumbsList, allTruncated }) => {
  const [truncatedPopperOpen, setTruncatedPopperOpen] = useState(false);
  const headerTranslation = usePageHeaderBundle();

  return (
    <Breadcrumb isFinal={allTruncated}>
      <TruncatedPopper
        trigger={
          <EllipsisButton
            onClick={() => setTruncatedPopperOpen(!truncatedPopperOpen)}
            aria-label={headerTranslation.getMessage(
              'page-header-breadcrumb-truncation-label',
            )}
          >
            <Icon type={ellipsisH} size="large" />
          </EllipsisButton>
        }
        withCloseButton={false}
        onCloseButtonClick={() => setTruncatedPopperOpen(false)}
        isOpen={truncatedPopperOpen}
        autoFocus={true}
      >
        <BreadcrumbGroupWrapper>
          <BreadcrumbGroup>{breadcrumbsList}</BreadcrumbGroup>
        </BreadcrumbGroupWrapper>
      </TruncatedPopper>
    </Breadcrumb>
  );
};

export default TruncationIconWithPopover;
